import { Caveat } from 'next/font/google';

const caveat = Caveat({
  subsets: ['latin'],
  weight: ['400', '700'], // Specify the weights you want to use
});

const TitleMain = ({ text }) => {
  return (
    <div
      className={`text-white text-4xl md:text-5xl lg:text-6xl font-bold text-center pt-5 pb-8  `}
    >
      <h2 className={caveat.className}>{text}</h2>
    </div>
  );
};

export default TitleMain;
